export const GlobalDefine = {
    TEST_ACTION: 'test_ACTION',
    IS_NUMBER_PORTAL: "IS_NUMBER_PORTAL"
};